import { FunctionalComponent, h, JSX } from "preact";
// import { Link } from 'preact-router/match';
import style from "./style.scss";

const Button = ({
  children,
  type = "primary",
  ...props
}: JSX.HTMLAttributes<HTMLAnchorElement> & {
  type?: "primary" | "outlined";
}) => {
  return (
    <a {...props} className={[props.className || "", style[type]].join(" ")}>
      {children}
    </a>
  );
};

export default Button;
